import { BehaviorSubject, Observable, combineLatest, of } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { CoreZoneApiService } from '@src/app/services/core-api/api/core-zone-api.service';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchBarComponent } from '../search-bar/search-bar.component';
import { SelectedCompanyService } from '@src/app/services/selected-company-service/selected-company.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ZonarUIMaterialModule } from '@zonar-ui/material';
import { orderBy } from 'lodash';

@Component({
  selector: 'app-category-content',
  standalone: true,
  imports: [
    CommonModule,
    ZonarUIMaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    SearchBarComponent,
    SpinnerComponent,
  ],
  templateUrl: './category-content.component.html',
  styleUrls: ['./category-content.component.scss']
})
export class CategoryContentComponent implements OnInit {
  categories$: Observable<{ color: string; name: string }[]>;
  searchTerm$ = new BehaviorSubject<string>('');
  errorMsg: string | null = null;

  constructor(
    private currentCompany$: SelectedCompanyService,
    private zoneApiService: CoreZoneApiService,
  ) { }

  ngOnInit(): void {
    this.subscribeToCategories();
  }

  subscribeToCategories() {
    this.categories$ = this.currentCompany$.getCurrentCompany().pipe(
      switchMap((companyId) => this.getCategoriesWithSearch(companyId)),
      catchError(respError => {
        this.errorMsg = respError?.error?.message || 'Something went wrong!';
        return of([]);
      })
    )
  }

  getCategoriesWithSearch(companyId: string) {
    return combineLatest([
      this.getCategories(companyId),
      this.searchTerm$.asObservable(),
    ]).pipe(
      map(([categories, searchTerm]) => {
        return categories.filter(({ name }) => name.toLowerCase().trim().includes(searchTerm.toLowerCase().trim()));
      }),
    );
  }

  onSearch(text: string) {
    this.searchTerm$.next(text);
  }

  selectCategory(category) {
    console.log('category', category);
  }

  createCategory() {
  }

  getCategories(companyId: string) {
    return this.zoneApiService.getCategories({ companyId, status: `ACTIVE`, sort: `name:asc`, visible: true });
  }

  getStyles(category) {
    return { 'backgroundColor': category.color, 'visibility': { 'hide': !category.color } };
  }
}
